import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_LIST_SECURITY_GROUPS } from "./security.constants";

const ListSecurityGroups = Loadable(
  lazy(() =>
    import("./ListSecurityGroups").then(
      ({ ListSecurityGroups }) => ({ default: ListSecurityGroups })
    )
  )
);

export const securityRoutes = [
 
      {
        path: `${APP_FILE_LIST_SECURITY_GROUPS}`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.ROLE]}>
            <ListSecurityGroups />
          </AuthorizedRoute>
        ),
      },
];
